export enum ReportTypeEnum {
  'Счет-оферта',
  'Договор',
}
